'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _googleLoginOrSignup = require('./google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _loginTrigger = require('./login-trigger');

var _loginTrigger2 = _interopRequireDefault(_loginTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* -----------  SIGNUP  ----------------------------------- */

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */
var CreateAccountForm = _baseForm2['default'].createFormClass({

    displayName: 'CreateAccountForm',

    propTypes: {
        'header': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string,
        'isInline': _react2['default'].PropTypes.bool,
        'isVertical': _react2['default'].PropTypes.bool, // only works for inline
        'inlineSideText': _react2['default'].PropTypes.string,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'isFromApiPricing': _react2['default'].PropTypes.bool,
        'planId': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'async': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'async': true
        };
    },

    getInitialState: function getInitialState() {
        return {
            'errors': this.props.errors,
            'emailAddress': '',
            'isProcessing': false,
            'isInline': false,
            'isVertical': false,
            'isOptedIn': true
        };
    },

    componentDidMount: function componentDidMount() {
        if (!this.props.isInline) {
            // This is a modal, so focus on the email address input element
            (0, _setTimeout2['default'])(function () {
                $(_reactDom2['default'].findDOMNode(this)).find("input[name='signup[email_address]']").focus();
            }.bind(this), 500);
        }
    },

    onEmailChange: function onEmailChange(event) {
        this.setState({
            'emailAddress': event.target.value.trim()
        });
    },

    onOptInChange: function onOptInChange(event) {
        this.setState({
            'isOptedIn': event.target.checked
        });
    },

    onSubmit: function onSubmit(evt) {

        evt.preventDefault();

        if (this.state.isProcessing === false) {

            // Retrieve the values from the email field one more time
            // prior to submit. This fixes an issue where Safari auto-complete
            // would not trigger the on*Change events for these fields.
            var root = _reactDom2['default'].findDOMNode(this);
            var emailAddress = $('#sign_up_email_address_input', root).val();

            this.setState({
                'errors': null,
                'isProcessing': true,
                'emailAddress': emailAddress
            });

            if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {

                this.setState({
                    'errors': { 'named': { 'email_address': 'Invalid email address' } },
                    'isProcessing': false
                });
            } else if (!this.props.async) {

                // Inline submit
                $('#sign_up_form', root).submit();
            } else {

                // Async submit
                this.submitAsync(function (resp) {

                    this.setState({
                        'isProcessing': false
                    });

                    // Display notification
                    if (resp.notification) {
                        hellofaxJS.createNotification({
                            'text': resp.notification.message,
                            'class_name': resp.notification.type
                        });
                    }

                    // Close the signup modal and show the login one
                    if (resp.show_login_form) {
                        $('.m-modal--close', '#create_account_modal').click();
                        $(document).trigger('login-trigger', { 'displayCaptcha': resp.display_captcha });
                        return;
                    }

                    // Redirect to redirect_url
                    if (resp.success === true && resp.redirect_url) {
                        document.location = resp.redirect_url;
                    }

                    // Failure
                    if (!resp.success) {

                        // Display error message
                        if (resp.error && !resp.notification_message) {
                            this.setState({
                                'errors': { 'global': resp.error.message }
                            });
                        }
                    }
                }, function () {

                    // Unexpected error
                    this.setState({
                        'errors': { 'global': 'An unexpected error occurred' },
                        'isProcessing': false
                    });
                });
            }
        }

        return false;
    },

    render: function render() {
        var isVertical = !this.props.isInline || this.props.isVertical; // is vertical (even if not inline)
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var rowClassNames = (0, _classnames2['default'])({
            'row': true,
            'text-center': true,
            'bg-plume': this.props.isInline ? true : false,
            'm-create-account--inline-container': this.props.isInline && !this.props.isVertical,
            'm-create-account--inline-container-vertical': this.props.isInline && this.props.isVertical,
            'l-padding-v-20': this.props.isInline ? true : false
        });

        var includeInlineText = function includeInlineText(text) {
            return _jsx('div', {
                className: 'm-create-account--login-side-text columns small-12 large-4 l-margin-v-20 '
            }, void 0, _jsx('h2', {
                className: 'c-ashen'
            }, void 0, text));
        };

        var formColumnClassNames = (0, _classnames2['default'])({
            'text-left m-create-account--sign-up': !isVertical,
            'columns small-12 l-margin-v-20 text-center': true,
            'large-5 large-left': !isVertical
        });
        var buttonColumnClassNames = (0, _classnames2['default'])({
            'columns small-12 l-margin-v-20 text-center': true,
            'large-3 large-left': !isVertical,
            'm-create-account--inline-google-login': !isVertical,
            'm-create-account--modal-google-login': isVertical
        });
        var submitButtonClassNames = (0, _classnames2['default'])({
            'm-create-account--inline-create-account-button': !isVertical,
            'm-create-account--modal-create-account-button': isVertical
        });

        var redirectUrl;
        if (this.props.redirectUrl) {
            redirectUrl = _jsx('input', {
                type: 'hidden',
                name: 'signup[redirect_url]',
                value: this.props.redirectUrl
            });
        }

        var isFromApiPricing;
        if (this.props.isFromApiPricing) {
            isFromApiPricing = _jsx('input', {
                type: 'hidden',
                name: 'is_from_api_pricing',
                value: this.props.isFromApiPricing ? "1" : ""
            });
        }

        var planId;
        if (this.props.planId) {
            planId = _jsx('input', {
                type: 'hidden',
                name: 'plan_id',
                value: this.props.planId
            });
        }

        var errors;
        if (this.state.errors) {
            errors = _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error'
            }, void 0, this.renderErrorText()));
        }

        var buttonText = this.props.buttonText ? this.props.buttonText : 'SIGN UP FREE';
        if (this.state.isProcessing) {
            buttonText = 'PROCESSING...';
        }

        var loginUrl = _hfReactHelper2['default'].urlHelper('account/logIn');
        var loginTrigger = _jsx(_loginTrigger2['default'], {
            linkText: 'Login',
            buttonText: 'Sign In',
            header: 'Welcome back',
            googleOpenIdUrl: this.props.googleOpenIdUrl,
            loginUrl: loginUrl,
            redirectUrl: this.props.redirectUrl,
            recoverPasswordForm: this.props.recoverPasswordForm,
            loginForm: this.props.loginForm,
            hideRememberMe: this.props.hideRememberMe
        }, void 0);

        var loginPrompt = _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx('div', {
            className: 'm-create-account--login-prompt'
        }, void 0, 'Already have an account? ', loginTrigger));

        var googleOpenId;
        if (this.props.googleOpenIdUrl) {
            googleOpenId = _jsx('div', {
                className: buttonColumnClassNames
            }, void 0, _jsx('div', {
                className: !isVertical ? 'm-create-account--inline-google-login-border' : 'm-create-account--modal-google-login-border'
            }, void 0, _jsx('div', {
                className: !isVertical ? 'm-create-account--inline-google-login-or-image' : 'm-create-account--modal-google-login-or-image'
            })), _jsx('div', {
                className: !isVertical ? 'm-create-account--inline-google-login-button' : 'm-create-account--modal-google-login-button'
            }, void 0, _jsx(_googleLoginOrSignup2['default'], {
                openIdUrl: this.props.googleOpenIdUrl,
                isOptedIn: this.state.isOptedIn,
                isLogIn: false
            })));
        }

        return _jsx('div', {
            className: 'm-create-account'
        }, void 0, _jsx('form', {
            id: 'sign_up_form',
            className: 'm-create-account--form',
            action: this.props.action,
            method: 'POST'
        }, void 0, _jsx('div', {
            className: rowClassNames
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx('h4', {}, void 0, this.props.header)), !isVertical ? includeInlineText(this.props.inlineSideText) : "", googleOpenId, _jsx('div', {
            className: formColumnClassNames
        }, void 0, _jsx('div', {
            className: 'small-10 small-offset-1 text-center'
        }, void 0, this.renderField('email_address', {
            'id': 'sign_up_email_address_input',
            'className': 'm-create-account--text-input ' + (isVertical ? 'm-create-account--email-vertical' : ''),
            'maxLength': '99',
            'placeholder': 'Enter your email',
            'onChange': this.onEmailChange,
            'tabIndex': tabOffset,
            'data-format': 'email'
        })), _jsx('div', {
            className: 'small-10 small-offset-1 small-text-left'
        }, void 0, _jsx('div', {
            className: 'm-create-account--opt-in-container'
        }, void 0, _jsx('div', {
            className: "m-create-account--opt-in-align" + (isVertical ? "-vertical" : "")
        }, void 0, _jsx('label', {}, void 0, this.renderField('is_opted_in_marketing_emails', {
            'className': 'm-create-account--text-input',
            'defaultChecked': 'checked',
            'tabIndex': tabOffset + 2,
            'onChange': this.onOptInChange
        }), ' Send me HelloSign updates')))), errors, this.renderHiddenFields(), _jsx('input', {
            type: 'hidden',
            name: 'async',
            value: this.props.async ? "1" : "0"
        }), _jsx('div', {
            className: 'l-margin-b-10 small-10 small-offset-1 small-text-center ' + (!isVertical ? 'large-text-left' : '')
        }, void 0, _jsx(_button2['default'], {
            onClick: this.onSubmit,
            buttonClass: submitButtonClassNames,
            buttonText: buttonText,
            buttonColor: 'grasshopper',
            buttonHoverColor: 'castle-rock',
            buttonTabIndex: tabOffset + 3
        }))), isVertical ? loginPrompt : ''), redirectUrl, isFromApiPricing, planId));
    }
});

module.exports = CreateAccountForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account-form.jsx
 ** module id = 749
 ** module chunks = 0
 **/